import state from './state';

export default {
  namespaced: true,
  state,
};



// WEBPACK FOOTER //
// ./src/store/modules/nav/index.js